/* LUCIELL — Schritt ① „Angebot & Farbe" im Baukasten „Dein Verein"
   (snippets/lc-verein-angebot.liquid, Angebots-Variante der Seite).

   Seit 14.10.2026 (Betreiber) waehlt die Kundin hier direkt das Angebot und
   darin die Farben — die Farbkacheln/Groessenknoepfe des Baukastens gibt es
   auf dieser Seite nicht mehr. Kasten 1 „1 Armband" hat eine Zeile
   (Armband 1), Kasten 2 „Kauf 1, krieg 1 gratis" (vorausgewaehlt) die Zeilen
   „1." (Armband 1, traegt die Charms) und „2." (zweites Band, nur das Band).
   Je Zeile: Bandfarbe aus einer weissen Liste mit Bild, Groesse aus einem Menue.

   ARMBAND 1 ist in beiden Kaesten dieselbe Wahl (Zeilen data-lc-va-band="1"),
   ein Kastenwechsel behaelt sie.
   ZWEITES BAND FOLGT ARMBAND 1 — je Feld, bis die Kundin es selbst setzt:
   Start = Farbe und Groesse von Armband 1. Waehlt sie in Zeile 1 eine neue
   Farbe oder Groesse, zieht Zeile „2." mit — ausser in dem Feld, das sie in
   Zeile „2." schon selbst gewaehlt hat (wie groesseFest in vereinswahl/v4).
   Ist eine Kombination nicht lieferbar, nimmt die Zeile die naechste
   lieferbare Groesse derselben Farbe.

   AUSGABE (Vertrag mit dem Baukasten lc-dein-verein-angebot.js):
     window.lcVereinAngebot = {
       modus: 'einzeln' | 'paar',
       band1: { variantId, farbe, groesse, preis } | null,
       zweitesBand: { variantId, farbe, groesse, preis } | null
     }
   Dasselbe Objekt wird bei jeder Aenderung neu beschrieben; dazu das
   document-Ereignis `lc:verein-angebot` (detail = Kopie). Hier wird NICHT
   gekauft und nichts gemessen — das macht der Baukasten mit diesem Zustand
   (er fuehrt auch die Galerie mit der Farbe von Armband 1).

   Reine Logik in Node getestet: shopify/dein-verein/tests/lc-verein-angebot.test.mjs */
(function () {
  'use strict';

  var TEXTE = { ausverkauft: 'ausverkauft', farbe: 'Bandfarbe' };
  var EREIGNIS = 'lc:verein-angebot';

  /* ── Reine Logik ── */

  // Betrag wie im Snippet (money_without_currency + " €"): 4490 -> "44,90 €".
  function euro(cent) {
    return (Math.round(Number(cent) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function frei(v) { return !!v && v.verfuegbar !== false; }

  // Variante zu Farbe x Groesse, sonst null.
  function variante(daten, farbe, groesse) {
    var liste = (daten && daten.varianten) || [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].farbe === farbe && liste[i].groesse === groesse) return liste[i];
    }
    return null;
  }

  // Ist irgendeine Groesse dieser Farbe lieferbar?
  function farbeFrei(daten, farbe) {
    var liste = (daten && daten.varianten) || [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].farbe === farbe && frei(liste[i])) return true;
    }
    return false;
  }

  // Farben fuer die Liste (Reihenfolge des Shops) mit frei true/false.
  function farbenStatus(daten) {
    return ((daten && daten.farben) || []).map(function (f) { return { wert: f, frei: farbeFrei(daten, f) }; });
  }

  // Groessen einer Farbe fuer das Menue mit frei true/false.
  function groessenStatus(daten, farbe) {
    return ((daten && daten.groessen) || []).map(function (g) {
      return { wert: g, frei: frei(variante(daten, farbe, g)) };
    });
  }

  // Lieferbare Wahl zu {farbe, groesse}: genau diese, sonst dieselbe Farbe in
  // der naechstgelegenen lieferbaren Groesse (bei Gleichstand die groessere),
  // sonst unveraendert (dann gibt es dieses Band nicht).
  function gueltig(daten, w) {
    if (frei(variante(daten, w.farbe, w.groesse))) return { farbe: w.farbe, groesse: w.groesse };
    var gs = (daten && daten.groessen) || [];
    var start = gs.indexOf(w.groesse);
    if (start === -1) start = 0;
    for (var d = 1; d < gs.length; d++) {
      var kandidaten = [start + d, start - d];
      for (var k = 0; k < kandidaten.length; k++) {
        var g = gs[kandidaten[k]];
        if (g !== undefined && frei(variante(daten, w.farbe, g))) return { farbe: w.farbe, groesse: g };
      }
    }
    return { farbe: w.farbe, groesse: w.groesse };
  }

  // Zustand: { modus, band1: {farbe, groesse}, zwei: {farbe, groesse}, fest: {farbe, groesse} }.
  // `fest` = Felder der Zeile „2.", die die Kundin selbst gesetzt hat.
  // start = daten.start (Liquid: Startvariante, Groesse L wenn lieferbar).
  function anfang(daten, start, modus) {
    var b1 = gueltig(daten, { farbe: start.farbe, groesse: start.groesse });
    return {
      modus: modus === 'einzeln' ? 'einzeln' : 'paar',
      band1: b1,
      zwei: { farbe: b1.farbe, groesse: b1.groesse },
      fest: { farbe: false, groesse: false }
    };
  }

  function kopie(z) {
    return {
      modus: z.modus,
      band1: { farbe: z.band1.farbe, groesse: z.band1.groesse },
      zwei: { farbe: z.zwei.farbe, groesse: z.zwei.groesse },
      fest: { farbe: z.fest.farbe, groesse: z.fest.groesse }
    };
  }

  // Armband 1 wird neu gesetzt (ganz): lieferbar machen, dann ziehen die nicht
  // selbst gesetzten Felder der Zeile „2." mit.
  function band1Setzen(daten, z, band1) {
    var n = kopie(z);
    if (!band1 || (band1.farbe === z.band1.farbe && band1.groesse === z.band1.groesse)) return n;
    n.band1 = gueltig(daten, { farbe: band1.farbe, groesse: band1.groesse });
    var w = { farbe: n.fest.farbe ? n.zwei.farbe : n.band1.farbe, groesse: n.fest.groesse ? n.zwei.groesse : n.band1.groesse };
    n.zwei = gueltig(daten, w);
    return n;
  }

  // Die Kundin setzt in einer Zeile von Armband 1 ein Feld ('farbe' | 'groesse').
  function einsSetzen(daten, z, feld, wert) {
    if (feld !== 'farbe' && feld !== 'groesse') return kopie(z);
    var b = { farbe: z.band1.farbe, groesse: z.band1.groesse };
    b[feld] = wert;
    return band1Setzen(daten, z, b);
  }

  // Die Kundin setzt in Zeile „2." ein Feld ('farbe' | 'groesse').
  function zweiSetzen(daten, z, feld, wert) {
    var n = kopie(z);
    if (feld !== 'farbe' && feld !== 'groesse') return n;
    n.zwei[feld] = wert;
    n.fest[feld] = true;
    n.zwei = gueltig(daten, n.zwei);
    return n;
  }

  function modusSetzen(z, modus) {
    var n = kopie(z);
    n.modus = modus === 'einzeln' ? 'einzeln' : 'paar';
    return n;
  }

  function bandAusgabe(v) {
    return { variantId: Number(v.id), farbe: v.farbe, groesse: v.groesse, preis: Number(v.preis) || 0 };
  }

  // Was der Baukasten liest: band1 bei lieferbarer Variante, zweitesBand nur
  // bei 'paar' und lieferbarer Variante.
  function ausgabe(daten, z) {
    var v1 = variante(daten, z.band1.farbe, z.band1.groesse);
    var v2 = variante(daten, z.zwei.farbe, z.zwei.groesse);
    return {
      modus: z.modus,
      band1: frei(v1) ? bandAusgabe(v1) : null,
      zweitesBand: z.modus === 'paar' && frei(v2) ? bandAusgabe(v2) : null
    };
  }

  // Preise der Kaesten (Cent). Kasten 1: Armband 1. Kasten 2: zu zahlen ist
  // das teurere der beiden Baender (1+1: das guenstigere ist gratis),
  // durchgestrichen beide zusammen. Unbekannte Variante zaehlt wie Armband 1.
  function preise(daten, z) {
    var v1 = variante(daten, z.band1.farbe, z.band1.groesse);
    var v2 = variante(daten, z.zwei.farbe, z.zwei.groesse);
    var p1 = v1 ? (Number(v1.preis) || 0) : 0;
    var p2 = v2 ? (Number(v2.preis) || 0) : p1;
    return { einzeln: p1, paar: Math.max(p1, p2), paarStreich: p1 + p2 };
  }

  /* ── Seite ── */

  var zaehler = 0;

  function veroeffentlichen(daten, z) {
    var a = ausgabe(daten, z);
    var ziel = window.lcVereinAngebot;
    if (!ziel || typeof ziel !== 'object') { ziel = {}; window.lcVereinAngebot = ziel; }
    ziel.modus = a.modus;
    ziel.band1 = a.band1;
    ziel.zweitesBand = a.zweitesBand;
    var kopieBand = function (b) {
      return b ? { variantId: b.variantId, farbe: b.farbe, groesse: b.groesse, preis: b.preis } : null;
    };
    var detail = { modus: a.modus, band1: kopieBand(a.band1), zweitesBand: kopieBand(a.zweitesBand) };
    try {
      document.dispatchEvent(new CustomEvent(EREIGNIS, { detail: detail }));
    } catch (e) { /* alter Browser: der Baukasten liest beim Klick und beim Kauf */ }
  }

  function starten(wurzel) {
    if (!wurzel || !wurzel.getAttribute || wurzel.getAttribute('data-lc-va-an')) return null;
    var knoten = wurzel.querySelector('[data-lc-va-daten]');
    if (!knoten) return null;
    var daten;
    try { daten = JSON.parse(knoten.textContent); } catch (e) { return null; }
    if (!daten || !daten.varianten || !daten.varianten.length) return null;
    wurzel.setAttribute('data-lc-va-an', '1');
    var nr = ++zaehler;

    function q(s) { return wurzel.querySelector(s); }
    function qa(s) { return Array.prototype.slice.call(wurzel.querySelectorAll(s)); }

    var kaesten = qa('[data-lc-va-kasten]');
    var liste = q('[data-lc-va-liste]');
    var opts = liste ? Array.prototype.slice.call(liste.querySelectorAll('[data-lc-va-opt]')) : [];
    // Zeilen: Kasten 1 + Kasten 2 „1." (Armband 1), Kasten 2 „2." (zweites Band).
    var zeilen = qa('[data-lc-va-band]').map(function (r) {
      return {
        band: r.getAttribute('data-lc-va-band') === '2' ? '2' : '1',
        aria: r.getAttribute('data-lc-va-aria') || '',
        knopf: r.querySelector('[data-lc-va-farbe]'),
        bild: r.querySelector('[data-lc-va-farbbild]'),
        name: r.querySelector('[data-lc-va-farbname]'),
        groesse: r.querySelector('[data-lc-va-groesse]')
      };
    });

    // Eindeutige Namen/IDs je Block (die Section darf zweimal auf der Seite stehen).
    qa('[data-lc-va-wahl]').forEach(function (r) { r.name = 'lc-va-' + nr; });
    if (liste) liste.id = 'lc-va-liste-' + nr;
    zeilen.forEach(function (zl) { if (zl.knopf && liste) zl.knopf.setAttribute('aria-controls', liste.id); });
    opts.forEach(function (o, i) { o.id = 'lc-va-' + nr + '-opt-' + i; });

    var z = anfang(daten, daten.start || { farbe: daten.varianten[0].farbe, groesse: daten.varianten[0].groesse }, 'paar');
    var offenBei = null;   // Zeile, fuer die die weisse Liste gerade offen ist

    function wahlVon(zl) { return zl.band === '2' ? z.zwei : z.band1; }

    function bildFuer(farbe) {
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].getAttribute('data-lc-va-opt') === farbe) return opts[i].getAttribute('data-lc-va-opt-bild') || '';
      }
      return '';
    }

    function optsMarkieren() {
      var farbe = offenBei ? wahlVon(offenBei).farbe : null;
      opts.forEach(function (o) {
        o.setAttribute('aria-selected', o.getAttribute('data-lc-va-opt') === farbe ? 'true' : 'false');
      });
    }

    function groesseZeichnen(menue, w) {
      var status = groessenStatus(daten, w.farbe);
      Array.prototype.slice.call(menue.options || []).forEach(function (opt) {
        var eintrag = null;
        for (var i = 0; i < status.length; i++) { if (status[i].wert === opt.value) eintrag = status[i]; }
        var istFrei = !eintrag || eintrag.frei;
        var text = istFrei ? opt.value : opt.value + ' – ' + TEXTE.ausverkauft;
        opt.disabled = !istFrei;
        if (opt.textContent !== text) opt.textContent = text;
      });
      if (menue.value !== w.groesse) menue.value = w.groesse;
    }

    function zeichnen() {
      kaesten.forEach(function (k) {
        var an = k.getAttribute('data-lc-va-kasten') === z.modus;
        k.classList.toggle('lc-va__kasten--an', an);
        var r = k.querySelector('[data-lc-va-wahl]');
        if (r) r.checked = an;
      });
      zeilen.forEach(function (zl) {
        var w = wahlVon(zl);
        if (zl.knopf) {
          zl.knopf.value = w.farbe;
          zl.knopf.setAttribute('aria-label', TEXTE.farbe + zl.aria + ': ' + w.farbe);
        }
        if (zl.name && zl.name.textContent !== w.farbe) zl.name.textContent = w.farbe;
        var src = bildFuer(w.farbe);
        if (zl.bild && src && zl.bild.getAttribute('src') !== src) zl.bild.setAttribute('src', src);
        if (zl.groesse) groesseZeichnen(zl.groesse, w);
      });
      optsMarkieren();
      var p = preise(daten, z);
      var e1 = q('[data-lc-va-preis="einzeln"]'); if (e1) e1.textContent = euro(p.einzeln);
      var e2 = q('[data-lc-va-preis="paar"]'); if (e2) e2.textContent = euro(p.paar);
      var s2 = q('[data-lc-va-streich]'); if (s2) s2.textContent = euro(p.paarStreich);
      veroeffentlichen(daten, z);
    }

    function neu(n) { z = n; zeichnen(); }

    function setzen(zl, feld, wert) {
      neu(zl.band === '2' ? zweiSetzen(daten, z, feld, wert) : einsSetzen(daten, z, feld, wert));
    }

    // Kaesten: Radio und Tipp auf den Kasten; Tipps in die Zeilen waehlen nicht um.
    kaesten.forEach(function (k) {
      var modus = k.getAttribute('data-lc-va-kasten');
      var r = k.querySelector('[data-lc-va-wahl]');
      if (r) r.addEventListener('change', function () { if (r.checked && z.modus !== modus) { schliessen(false); neu(modusSetzen(z, modus)); } });
      k.addEventListener('click', function (e) {
        var ziel = e && e.target;
        if (ziel && ziel.closest && ziel.closest('.lc-va__zeilen')) return;
        if (z.modus !== modus) { schliessen(false); neu(modusSetzen(z, modus)); }
      });
    });

    zeilen.forEach(function (zl) {
      if (!zl.groesse) return;
      zl.groesse.addEventListener('change', function () { setzen(zl, 'groesse', zl.groesse.value); });
    });

    /* ── Weisse Liste (Vorbild vereinswahl/v4), eine fuer alle Zeilen: oeffnen
       per Tipp, Enter, Leertaste, Pfeil; schliessen per Tipp daneben, Esc,
       Tab, nach der Wahl. ── */
    var aktiv = -1;
    function waehlbar(o) { return o.getAttribute('aria-disabled') !== 'true'; }
    function lege() {
      if (!offenBei || !liste) return;
      var w = wurzel.getBoundingClientRect();
      var f = offenBei.knopf.getBoundingClientRect();
      liste.style.minWidth = Math.round(f.width) + 'px';
      liste.style.maxHeight = Math.min(464, Math.round((window.innerHeight || 800) * 0.6)) + 'px';
      var links = f.left - w.left;
      var breite = liste.offsetWidth;
      if (links + breite > w.width) links = Math.max(0, w.width - breite);
      liste.style.left = Math.round(links) + 'px';
      liste.style.top = Math.round(f.bottom - w.top + 4) + 'px';
    }
    function insBild() {
      try {
        var f = offenBei.knopf.getBoundingClientRect();
        var l = liste.getBoundingClientRect();
        var hoehe = window.innerHeight || 0;
        var dy = 0;
        if (l.bottom + 12 > hoehe) dy = l.bottom + 12 - hoehe;
        if (f.top - dy < 8) dy = f.top - 8;
        if (dy > 2) window.scrollBy({ top: dy, behavior: 'smooth' });
      } catch (e) {}
    }
    function setzeAktiv(i, scrollen) {
      if (i < 0 || i >= opts.length) return;
      aktiv = i;
      opts.forEach(function (o, j) { o.classList.toggle('lc-va__opt--aktiv', j === i); });
      liste.setAttribute('aria-activedescendant', opts[i].id);
      if (scrollen) {
        var o = opts[i];
        if (o.offsetTop < liste.scrollTop) liste.scrollTop = o.offsetTop;
        else if (o.offsetTop + o.offsetHeight > liste.scrollTop + liste.clientHeight) liste.scrollTop = o.offsetTop + o.offsetHeight - liste.clientHeight;
      }
    }
    function naechster(von, schritt) {
      for (var i = von + schritt; i >= 0 && i < opts.length; i += schritt) if (waehlbar(opts[i])) return i;
      return von;
    }
    function oeffnen(zl) {
      if (!liste || !zl.knopf || offenBei === zl) return;
      if (offenBei) schliessen(false);
      offenBei = zl;
      liste.hidden = false;
      liste.setAttribute('aria-label', TEXTE.farbe + zl.aria);
      zl.knopf.setAttribute('aria-expanded', 'true');
      zl.knopf.parentNode.classList.add('lc-va__feld--offen');
      optsMarkieren();
      var gewaehlt = 0;
      var farbe = wahlVon(zl).farbe;
      opts.forEach(function (o, i) { if (o.getAttribute('data-lc-va-opt') === farbe) gewaehlt = i; });
      lege();
      setzeAktiv(gewaehlt, true);
      try { liste.focus({ preventScroll: true }); } catch (e) { liste.focus(); }
      insBild();
    }
    function schliessen(fokusZurueck) {
      if (!offenBei) return;
      var zl = offenBei;
      offenBei = null;
      liste.hidden = true;
      liste.removeAttribute('aria-activedescendant');
      zl.knopf.setAttribute('aria-expanded', 'false');
      zl.knopf.parentNode.classList.remove('lc-va__feld--offen');
      if (fokusZurueck) { try { zl.knopf.focus({ preventScroll: true }); } catch (e) {} }
    }
    function nimm(i) {
      var o = opts[i];
      if (!o || !waehlbar(o) || !offenBei) return;
      var zl = offenBei;
      schliessen(true);
      setzen(zl, 'farbe', o.getAttribute('data-lc-va-opt'));
    }
    if (liste) {
      zeilen.forEach(function (zl) {
        if (!zl.knopf) return;
        zl.knopf.addEventListener('click', function () { if (offenBei === zl) schliessen(true); else oeffnen(zl); });
        zl.knopf.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); oeffnen(zl); }
        });
      });
      liste.addEventListener('click', function (e) {
        var o = e.target && e.target.closest ? e.target.closest('[data-lc-va-opt]') : null;
        if (o) nimm(opts.indexOf(o));
      });
      liste.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); setzeAktiv(naechster(aktiv, 1), true); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setzeAktiv(naechster(aktiv, -1), true); }
        else if (e.key === 'Home') { e.preventDefault(); setzeAktiv(naechster(-1, 1), true); }
        else if (e.key === 'End') { e.preventDefault(); setzeAktiv(naechster(opts.length, -1), true); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); nimm(aktiv); }
        else if (e.key === 'Escape') { e.preventDefault(); schliessen(true); }
        else if (e.key === 'Tab') { schliessen(true); } // Fokus zurueck aufs Feld: Tab geht dann zur Groesse derselben Zeile
      });
      document.addEventListener('pointerdown', function (e) {
        if (!offenBei) return;
        var t = e.target;
        if (liste.contains(t) || offenBei.knopf.contains(t)) return;
        schliessen(false);
      }, true);
      window.addEventListener('resize', lege);
    }

    zeichnen();
    return { wurzel: wurzel, daten: daten, zustand: function () { return z; } };
  }

  function alleStarten() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lc-verein-angebot]'), starten);
  }

  window.lcVereinAngebotIntern = {
    starten: starten,
    euro: euro, variante: variante, farbeFrei: farbeFrei, farbenStatus: farbenStatus,
    groessenStatus: groessenStatus, gueltig: gueltig, anfang: anfang, band1Setzen: band1Setzen,
    einsSetzen: einsSetzen, zweiSetzen: zweiSetzen, modusSetzen: modusSetzen, ausgabe: ausgabe, preise: preise
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleStarten);
  else alleStarten();
  document.addEventListener('shopify:section:load', alleStarten);
})();
